module.exports = __webpack_public_path__ + "static/media/arrow.132815ac.svg";